import React from 'react';
import { date } from '../api';

export const ORDER_STATUSES = ['placed', 'confirmed', 'dispatched', 'delivered'];
export const NEXT_ORDER_STATUS = { placed: 'confirmed', confirmed: 'dispatched', dispatched: 'delivered' };

const ProgressStep = ({ status, number, completed, event, orderId }) => <div className={completed ? 'complete' : ''}
  data-testid={`order-progress-${orderId}-${status}`}>
  <span>{number}</span><strong>{status}</strong><small>{event ? date(event.at) : '—'}</small>
</div>;

export const OrderProgress = ({ order }) => {
  const currentStep = ORDER_STATUSES.indexOf(order.status);
  const events = new Map(order.history.map(event => [event.status, event]));
  return <div className="order-progress">{ORDER_STATUSES.map((status, index) => <ProgressStep key={status}
    orderId={order.id} status={status} number={index + 1} completed={index <= currentStep} event={events.get(status)} />)}</div>;
};